import { collection, getDocs } from 'firebase/firestore';
import Loading from '../components/Loading';
import React, { createContext, useEffect, useState } from 'react';
import { db } from '../firebase';

// Create a context
export const MyContext = createContext();

// Create a context provider component
export const MyProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([])
  const [projectCategory, setProjectCategory] = useState({})
  const [animationData, setAnimationData] = useState(null)
  const [CVLink, setCVLink] = useState(null)
  const [bannerImgLink, setBannerImgLink] = useState(null)
  
  useEffect(() => {
    const fetchCollectionData = async () => {
    const collectionRef = collection(db, 'projects');
    const collectionRef2 = collection(db, 'projectCategory');
    const collectionRef3 = collection(db, 'animationData');
    const collectionRef4 = collection(db, 'CVLink');
    const collectionRef5 = collection(db, 'bannerImgLink'); 
    try {
        const querySnapshot = await getDocs(collectionRef);
        const querySnapshot2 = await getDocs(collectionRef2);
        const querySnapshot3 = await getDocs(collectionRef3);
        const querySnapshot4 = await getDocs(collectionRef4);
        const querySnapshot5 = await getDocs(collectionRef5);
        let dataList = querySnapshot.docs.map(doc => ({
          id: doc.id, 
          ...doc.data()
        })); 
        dataList.sort(function(a, b) { 
          return new Date(b.date) - new Date(a.date);
        });
        let dataList2 = {}
        for(let i=0; i<querySnapshot2.docs.length; i++) {
          const categoryId = querySnapshot2.docs[i].id
          const categoryName = querySnapshot2.docs[i].data().name
          dataList2[categoryId] = categoryName
        }

        const dataList3= querySnapshot3.docs[0].data()
        // console.log('Data fetched from Firestore:', dataList);
        const dataList4= querySnapshot4.docs[0].data()
        const dataList5= querySnapshot5.docs[0].data()

        setProjects(dataList)
        setProjectCategory(dataList2)
        setAnimationData((JSON.parse(dataList3.json)))
        setCVLink((dataList4.link))
        setBannerImgLink((dataList5.image))
    } catch (error) {
        console.error('Error fetching documents: ', error);
    } finally{
        setLoading(false);
    }
  };
  fetchCollectionData()
  }, [])

  return (
  loading ? <Loading /> :
    <MyContext.Provider value={{ projects, projectCategory, animationData, CVLink, bannerImgLink }}>
      {children}
    </MyContext.Provider>
  );
};
